enum TournamentStatus {
    notStarted,
    ongoing,
    completed
}
export default TournamentStatus;